<div class="modal-window__header">
  <div
    *ngIf="isOnlyNotificationModal"
    class="modal-window__title validation-failed-title">
    <mat-icon
      class="warning-icon"
      svgIcon="warning"></mat-icon>
    <span class="err-modal-title-text">{{ title | translate }}</span>
  </div>
  <div
    *ngIf="!isOnlyNotificationModal"
    class="modal-window__title">
    {{ title | translate }}
  </div>
  <a
    *ngIf="!isOnlyNotificationModal"
    (click)="onDialogCloseClick()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
  <mat-divider class="divider"></mat-divider>
</div>

<div
  *ngFor="let contentItem of content"
  class="modal-window__label">
  <span style="white-space: pre-line">
    {{ contentItem | translate }}
  </span>
</div>

<div class="o-grid--medium u-mt--medium">
  <div
    *ngIf="!isOnlyNotificationModal"
    class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      (click)="onCancel()"
      class="button--sm button-secondary button-block">
      {{ localizationConstants.BUTTON_CANCEL | translate }}
    </button>
  </div>
  <div
    *ngIf="!isOnlyNotificationModal"
    class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      (click)="onConfirm()">
      {{ localizationConstants.BUTTON_CONFIRM | translate }}
    </button>
  </div>
  <div
    *ngIf="isOnlyNotificationModal"
    class="o-grid__item col-md-3 button-ok">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      (click)="onDialogCloseClick()">
      {{ localizationConstants.BUTTON_OK | translate }}
    </button>
  </div>
</div>
